import { Component } from '@angular/core';
import { SkeletonComponent } from '@esolutions/design-system-ng/components';

@Component({
  selector: 'app-welcome-placeholder',
  templateUrl: './welcome-placeholder.component.html',
  styleUrls: ['./welcome-placeholder.component.scss'],
  imports: [SkeletonComponent],
  standalone: true
})
export class WelcomePlaceholderComponent {}
